import { create } from "zustand";

interface ErrorHandlingState {
    code: string,
    message: string,
    isShowModal: boolean,
    showModal: (code: string, message: string) => void,
    hideModal: () => void
}

export const useErrorHandlingStore = create<ErrorHandlingState>((set) => ({
    code:"",
    message:"",
    isShowModal: false,
    showModal: (code, message) => {
        set({
            code,
            message,
            isShowModal: true
        })
    },
    hideModal: () => {
        set({
            code: "",
            message: "",
            isShowModal: false
        })
    }
}))